import { Component, OnInit } from '@angular/core';
import * as moment from 'moment/moment';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {
  today: any = Date.now();
  // @ts-ignore
  nowMoment: any = moment().format('HH:mm');
  subMom: any = moment(Date.now()).subtract({minutes:30}).format('HH:mm');
  test: any = moment(this.today).subtract({minutes:30}).format('HH:mm');
  constructor() {
  }
  ngOnInit(): void {
  }

}
